"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageUnloadContext = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isBrowser = typeof window !== 'undefined';
var PageUnloadContext = (0, _preactCompat.createContext)({
  lock: function lock() {
    throw new Error('Something went wrong. The page unload context was used without a provider');
  },
  unlock: function unlock() {
    throw new Error('Something went wrong. The page unload context was used without a provider');
  }
});
exports.PageUnloadContext = PageUnloadContext;

var PageUnloadContextProvider = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PageUnloadContextProvider, _PureComponent);

  var _super = _createSuper(PageUnloadContextProvider);

  function PageUnloadContextProvider() {
    var _this;

    (0, _classCallCheck2.default)(this, PageUnloadContextProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasUnsavedChanges", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUnload", function (e) {
      if (_this.hasUnsavedChanges.current) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "value", {
      lock: function lock(content) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        _this.hasUnsavedChanges.current = content !== '' && content !== data;
      },
      unlock: function unlock() {
        _this.hasUnsavedChanges.current = false;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(PageUnloadContextProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isBrowser) {
        window.addEventListener('beforeunload', this.onUnload);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (isBrowser) {
        window.removeEventListener('beforeunload', this.onUnload);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return (0, _preact.h)(PageUnloadContext.Provider, {
        value: this.value
      }, children);
    }
  }]);
  return PageUnloadContextProvider;
}(_preactCompat.PureComponent);

var _default = PageUnloadContextProvider;
exports.default = _default;